// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.double-slider-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: #fdfdfd;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  max-width: 300px;
  margin: auto;
  font-family: 'Segoe UI', sans-serif;
}

/* Main title label (range name) */
.double-slider-container > label {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.3rem;
  color: #333;
}

/* Unit selector section */
.unit-selector {
  display: flex;
  flex-direction: column;
}

.unit-selector label {
  font-weight: 500;
  font-size: 0.9rem;
  margin-bottom: 0.3rem;
  color: #444;
}

.input-field-select {
  padding: 0.45rem 0.6rem;
  font-size: 0.9rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: white;
  transition: border-color 0.2s ease-in-out;
}

.input-field-select:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
}

/* Input group for Min/Max */
.input-group {
  display: flex;
  gap: 1rem;
  width: 100%;
  flex-wrap: wrap;
}

.input-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.input-label {
  font-weight: 500;
  font-size: 0.85rem;
  margin-bottom: 0.3rem;
  color: #555;
}

.input-field-slider {
  width: 100%;
  padding: 0.4rem 0.6rem;
  font-size: 0.9rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-sizing: border-box;
}

.input-field-slider:focus {
  border-color: #28a745;
  outline: none;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/Components/SideBarSection/DoubleSlider/DoubleSlider.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;AACrC;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C","sourcesContent":[".double-slider-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem;\n  border-radius: 10px;\n  background-color: #fdfdfd;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n  max-width: 300px;\n  margin: auto;\n  font-family: 'Segoe UI', sans-serif;\n}\n\n/* Main title label (range name) */\n.double-slider-container > label {\n  font-weight: 600;\n  font-size: 1rem;\n  margin-bottom: 0.3rem;\n  color: #333;\n}\n\n/* Unit selector section */\n.unit-selector {\n  display: flex;\n  flex-direction: column;\n}\n\n.unit-selector label {\n  font-weight: 500;\n  font-size: 0.9rem;\n  margin-bottom: 0.3rem;\n  color: #444;\n}\n\n.input-field-select {\n  padding: 0.45rem 0.6rem;\n  font-size: 0.9rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background-color: white;\n  transition: border-color 0.2s ease-in-out;\n}\n\n.input-field-select:focus {\n  border-color: #007bff;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);\n}\n\n/* Input group for Min/Max */\n.input-group {\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.input-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.input-label {\n  font-weight: 500;\n  font-size: 0.85rem;\n  margin-bottom: 0.3rem;\n  color: #555;\n}\n\n.input-field-slider {\n  width: 100%;\n  padding: 0.4rem 0.6rem;\n  font-size: 0.9rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  box-sizing: border-box;\n}\n\n.input-field-slider:focus {\n  border-color: #28a745;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
